import { Relieved, LeftArrow } from 'app/components/icons'
import clsx from 'clsx'
import styles from './styles.module.scss'

function StartChatButton({ onClick, label, className }) {
  return (
    <button onClick={onClick} className={clsx(styles.start_messaging, className)}>
      <div className={styles.start_messaging_content}>
        <span className={styles.start_messaging_icons}>
          <Relieved className={styles.start_messaging_icons_real} color="#fff" />
        </span>
        <span className={styles.start_messaging_title}>{label}</span>
      </div>
      <div className={styles.start_messaging_icon}>
        <LeftArrow color="#fff" />
      </div>
    </button>
  )
}

export default StartChatButton
